import React, { FC } from 'react';
import PaymentMode, { calculateTotal } from './PaymentMode';

const SingleMode: FC<any> = ({ mode, total, selected }: any) => {
  const calculatedTotal = calculateTotal(total, mode.discount);

  return (
    <PaymentMode mode={mode} selected={selected}>
      <div className="title">Pay in Full</div>
      <div className="total">{`${(calculatedTotal / 100).toFixed(2)} $`}</div>
    </PaymentMode>
  );
};

export default SingleMode;
